// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__h0eoq"};